// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';

const UserSettingsNavigationItem = ({label, path}) =>
    <li className='user-settings-navigation-item'>
        <Link
            activeClassName='selected'
            to={`/settings/${path}`}
        >
            <FormattedMessage id={label}/>
        </Link>
    </li>;

UserSettingsNavigationItem.displayName = 'UserSettingsNavigationItem';
UserSettingsNavigationItem.propTypes = {
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
};

export default UserSettingsNavigationItem;



// WEBPACK FOOTER //
// ./src/user/shared/components/user-settings/user-settings-navigation-item.js